import { render, staticRenderFns } from "./AnchorageCustodialInput.vue?vue&type=template&id=3966dcd6&"
import script from "./AnchorageCustodialInput.vue?vue&type=script&lang=ts&"
export * from "./AnchorageCustodialInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports